import './utils/suppressUnloadViolation';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/TabPanel.scss';
import App from './App';

// Theme styles are loaded by the matching dx-theme links in public/index.html.

import themes from 'devextreme/ui/themes';

const isDarkMode =
  localStorage.getItem('theme') === 'dark' ||
  document.body.classList.contains('theme-dark');

themes.current(isDarkMode ? 'material.blue.dark.compact' : 'material.blue.light.compact');

import('./services/regionalSettings').then(({ initRegionalSettings }) => {
  initRegionalSettings();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

